module.exports = __webpack_public_path__ + "img/ff3.78d7ad50.jpg";